<template>
    <div>
        <div class="container">
            <div class="infoContain">
                <div>
                    <ValidationObserver v-slot="{ handleSubmit }">
                        <form class="infoBoxForm" @submit.prevent="handleSubmit(onClickNextBtn)">
                            <div class="flex mobileFlex">
                                <div class="inputBox infoBox wd50">
                                    <label>아이디<span class="labelItem">*</span></label>
                                    <input v-model="signupInfo.id" maxlength="20" disabled>
                                </div>
                                <ValidationProvider class="inputBox infoBox wd50" name="이메일" rules="required|email" v-slot="{errors}">
                                    <label>이메일<span class="labelItem">*</span></label>
                                    <input v-model="signupInfo.email" maxlength="40">
                                    <span class="notValidationTxt">{{errors[0]}}</span>
                                </ValidationProvider>
                            </div>
                            <div class="flex mobileFlex">
                                <ValidationProvider class="inputBox infoBox wd50" name="휴대폰번호" rules="required|mobileTel" v-slot="{errors, valid}">
                                    <label>휴대폰 번호<span class="labelItem">*</span></label>
                                    <input v-model="signupInfo.phoneNumber" @keypress="eventUtil.onKeyPressForOnlyDigit($event)" maxlength="11">
                                    <input type="button" value="인증번호 받기" @click="onClickRequestVerifyNumber(valid)">
                                    <span class="notValidationTxt">{{ errors[0] }}</span>
                                </ValidationProvider>
                                <ValidationProvider class="inputBox infoBox wd50" name="인증번호" rules="verifyNum" v-slot="{errors, valid}">
                                    <label>인증번호 6자리 입력</label>
                                    <input v-model="verifyNumber" maxlength="6" @keypress="eventUtil.onKeyPressForOnlyDigit($event)" :placeholder="counterPlaceHolder">
                                    <input type="button" value="확인" @click="onClickConfirmVerifyNumber(valid)" :disabled="counter == 0">
                                    <span class="notValidationTxt">{{errors[0]}}</span>
                                    <vac ref="verifyNumberCounter" :autoStart="false" :end-time="new Date().getTime() + 180000">
                                        <template v-slot:process="{ timeObj }">
                                            {{onProcesssVerifyNumberCounter(timeObj)}}
                                        </template>
                                        <template v-slot:finish>
                                            {{onFinishVerifyNumberCounter()}}
                                        </template>
                                    </vac>
                                </ValidationProvider>
                            </div>
                            <div class="flex mobileFlex">
                                <ValidationProvider class="inputBox infoBox wd50" name="이름" rules="required|name" v-slot="{errors}">
                                    <label>이름<span class="labelItem">*</span></label>
                                    <input v-model="signupInfo.name" maxlength="16">
                                    <span class="notValidationTxt">{{errors[0]}}</span>
                                </ValidationProvider>
                                <ValidationProvider class="inputBox infoBox wd50" name="생년월일" rules="required|dateNoHyphen" v-slot="{errors}">
                                    <label>생년월일<span class="labelItem">*</span></label>
                                    <input v-model="signupInfo.birthday" maxlength="10" placeholder="YYYYMMDD">
                                    <span class="notValidationTxt">{{errors[0]}}</span>
                                </ValidationProvider>
                            </div>
                            <div class="flex mobileFlex">
                                <div class="inputBox infoBox">
                                    <label>성별<span class="labelItem">*</span></label>
                                    <div class="bspRadio">
                                        <b-form-group v-slot="{ ariaDescribedby }">
                                            <b-form-radio-group
                                                id="btn-radios-1"
                                                v-model="signupInfo.gender"
                                                :options="genderOptions"
                                                :aria-describedby="ariaDescribedby"
                                                name="radios-btn-default"
                                                buttons
                                            ></b-form-radio-group>
                                        </b-form-group>
                                    </div>
                                </div>
                            </div>
                            <Address :signupInfo="signupInfo" :childDataLoaded="childDataLoaded" @set-address="setAddress"/>
                            <div class="btnBox flex topPd">
                                <button type="button" class="btnFont redborderBtn"  @click="onClickBeforeBtn">이 전</button>
                                <button type="submit" class="btnFont redBtn">다 음</button>
                            </div>
                        </form>
                    </ValidationObserver>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ValidationObserver, ValidationProvider} from 'vee-validate'
import {mapGetters, mapMutations, mapActions} from 'vuex'
import Address from '@/components/join/Address'
import * as eventUtil from '@/utils/eventUtil'
import * as addressFind from '@/utils/addressFind'

export default {
    components:{
        ValidationObserver,
        ValidationProvider,
        Address
    },
    mounted(){
        this.signupInfo.id = this.getKakaoId;
        this.childDataLoaded = true;
    },
    data() {
        return {
            eventUtil: eventUtil,
            signupInfo:{
                roleName: this.$role.USER,
                id: this.getKakaoId,
                password: '',
                name: '',
                email: '',
                phoneNumber: '',
                birthday: '',
                address: '',
                addressDetail: '',
                gender: 'M',
                isKakao: true
            },
            checkedPhoneNumber: '', // 인증을 요청한 전화번호
            isVerified: false,      // 전화번호 인증 여부
            verifyNumber: '',       // 인증번호
            counter: 0,             // 인증번호 유효 시간 카운터
            counterPlaceHolder: '', // 인증번호 유효 시간 카운터(출력용)
            addr1: '',              // addressFind util 주소검색 결과
            postcode: '',           // addressFind util 주소검색 결과(우편번호)
            genderOptions: [
                { text: '남', value: 'M' },
                { text: '여', value: 'F' },
            ],
            selected: 'man',
            options: [
                { text: '남', value: 'man' },
                { text: '여', value: 'woman' },
            ],
            childDataLoaded : false
        }
    },
    computed:{
        ...mapGetters('join',[
            'getKakaoId',
            'getType'
        ]),
    },
    methods:{
        ...mapMutations('join',[
            'setCurrentTab',
            'setCompletedInfo'
        ]),
        ...mapActions('auth', [
            'signup',
        ]),
        ...mapActions('sms', [
            'requestVerifyNumber',
            'confirmVerifyNumber'
        ]),
        onClickRequestVerifyNumber(isValidPhoneNumber){
            if(!isValidPhoneNumber || this.signupInfo.phoneNumber === ''){
                this.$alert("알림", "휴대폰번호를 확인해주세요.");
                return
            }
            
            const phoneNumber = this.signupInfo.phoneNumber
            this.isVerified = false

            this.requestVerifyNumber({
                phoneNumber: phoneNumber,
                contents: '[경희대학교 AgeTech Platform] 회원가입 전화번호 인증'
            })
            .then((response) => {
                const data = response.data

                if(data.RESULT == 'true'){
                    this.checkedPhoneNumber = phoneNumber // 인증번호를 요청한 전화번호 저장
                    this.$refs.verifyNumberCounter.startCountdown('restart')
                    this.$alert("알림", "인증번호를 발송했습니다.(유효시간 3분) <br>"+
                    "인증번호가 오지 않으면 입력하신 정보가 정확한지 확인하여 주세요.<br>" +
                    "이미 가입된 번호이거나, 가상전화번호는 인증번호를 받을 수 없습니다.");
                }
                else{
                    this.checkedPhoneNumber = '' // 인증번호를 요청한 전화번호 초기화
                    this.$refs.verifyNumberCounter.finishCountdown()
                    if(data.ERROR_CODE == 'SUCCESSIVE_REQUEST' || data.ERROR_CODE == 'BLOCKED'){
                        this.$alert("알림", "5분 뒤에 다시 시도해주세요.");
                    }
                    else{
                        this.$alert("알림", "인증번호 요청을 실패했습니다.");
                    }
                }
            })
            .catch(()=>{
                this.checkedPhoneNumber = '' // 인증번호를 요청한 전화번호 초기화
                this.$refs.verifyNumberCounter.finishCountdown()
                this.$alert("알림", "인증번호 요청을 실패했습니다.");
            })
        },
        onClickConfirmVerifyNumber(isValidVerifyNumber){
            if(!isValidVerifyNumber || this.verifyNumber === ''){
                return
            }

            this.confirmVerifyNumber({
                phoneNumber: this.checkedPhoneNumber,
                verifyNum: this.verifyNumber
            })
            .then((response) =>{
                const data = response.data

                if(data.RESULT == "true"){
                    this.isVerified = true
                    this.$refs.verifyNumberCounter.finishCountdown()
                    this.$alert("알림", "인증되었습니다.");
                }
                else{
                    this.isVerified = false
                    this.$alert("알림", "유효하지 않은 인증번호 입니다.");
                }
            })
            .catch(() => {
                this.isVerified = false
                this.$alert("알림", "요청 실패");
            })
        },
        onProcesssVerifyNumberCounter(timeObj){
            this.counter = (timeObj.m ) * 60 + timeObj.s
            this.counterPlaceHolder = `${timeObj.m}:${timeObj.s}`
        },
        onFinishVerifyNumberCounter(){
            this.counter = 0
            this.counterPlaceHolder = ''
        },
        onClickSearchAdderss(){
            addressFind.FindAddress(this);
        },
        onClickBeforeBtn(){
            this.signupInfo.id = ''
            this.signupInfo.email = ''
            this.signupInfo.phoneNumber = ''
            this.signupInfo.name = ''
            this.signupInfo.birthday = ''
            this.signupInfo.gender = 'M'
            this.signupInfo.address = ''
            this.signupInfo.addressDetail = ''
            this.checkedPhoneNumber = ''
            this.isVerified = false
            this.verifyNumber = ''
            this.counter = 0
            this.counterPlaceHolder = ''
            this.addr1 = ''
            this.postcode = ''       

            this.setCurrentTab(1)
        },
        onClickNextBtn(){
            if(!(this.isVerified && this.signupInfo.phoneNumber === this.checkedPhoneNumber)){
                this.$alert("알림", "전화번호를 인증해주세요.");
                return
            }

            const signupInfo = this.signupInfo
            this.signup(signupInfo)
            .then(() => {
                this.setCompletedInfo(signupInfo)
                this.setCurrentTab(3)
            })
            .catch((error) => {
                var data = error.response.data
                switch(data.ERROR){
                    case "ALREADY_EXIST_EMAIL":
                        this.$alert("알림", "사용중인 이메일 입니다.")
                        break
                    case "ALREADY_EXIST_PHONE_NUMBER":
                        this.$alert("알림", "사용중인 전화번호 입니다.")
                        break
                    default:
                        this.$alert("알림", "요청 실패")
                        break
                }
            })
        },
        setAddress(address, addressDetail){
            this.signupInfo.address = address;
            this.signupInfo.addressDetail = addressDetail;
		}
    }
}
</script>

<style scoped lang="scss">
    .checkBoxForm ::v-deep {
        @import "~bootstrap/dist/css/bootstrap.min";
        @import "~bootstrap-vue/dist/bootstrap-vue.min";
    }
    .bspRadio ::v-deep {
        @import "~bootstrap/dist/css/bootstrap.min";
    }
</style>

<style scoped>

</style>
